// extracted by mini-css-extract-plugin
module.exports = {"image-container":"style_image-container__Sun5a","spin-box":"style_spin-box__TK0YG","spin":"style_spin__1wLUs","no-image-css":"style_no-image-css__2uZuA"};